module.exports = __webpack_public_path__ + "static/media/auto_icon_yl.ea28c214.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/auto_icon_yl.svg
// module id = 1211
// module chunks = 0